export default "__VITE_ASSET__BJVHHmsz__"